define('common/components/nunjucks-config/main',[
    'njs',
    'nunjucks',
    'common/components/nunjucks-config/nunjucks-filters',
    'common/components/nunjucks-config/nunjucks-globals',
    'i18next',
    '@discoveryedu/nebula-components',
    '@discoveryedu/platform-components',
    '@discoveryedu/platform-pages/i18nPluralTerms'
], function(
    requirenjs,
    Nunjucks,
    nunjucksFilters,
    nunjucksGlobals,
    i18next,
    NebulaComponents,
    PlatformComponents,
    platformPagesI18nPluralTerms
) {
    'use strict';

    return {

        "njsEnv": null,

        "init": function (done, messages, locale) {
            // i18next expects languages in standard BCP 47 format, with hyphens:
            // https://www.i18next.com/how-to/faq#how-should-the-language-codes-be-formatted
            var formattedLocale = locale ? locale.replace(/_/g, '-') : 'en';

            // hax to make this code run only once....
            if (!this.njsEnv) {
                this.njsEnv = new Nunjucks.Environment(new Nunjucks.WebLoader('/static'));

                requirenjs.init(this.njsEnv);

                // Default to not escaping html anywhere, dont change this
                this.njsEnv.opts.autoescape = true;

                if (messages) {
                    var configObj = {
                        'fallbackLng': false,
                        'lng': formattedLocale,
                        'resources': {},
                        'returnEmptyString': false
                    };
                    configObj.resources[formattedLocale] = {
                        'translation': messages
                    };
                    this.configureI18Next(configObj);
                } else {
                    this.configureI18Next({
                        'fallbackLng': false,
                        'lng': 'en'
                    });
                }

                this.addFilters(this.njsEnv);
                this.addGlobals(this.njsEnv);
            }

            done && done();

        },

        "configureI18Next": function(options){
            // English plurals from nunjucks templates are added at runtime
            // (see nunjucks-globals.js in this directory) but plurals from
            // Vue apps need to be added separately since they won't be run
            // through nunjucks. This is where i18next is initialized regardless,
            // which is why these terms are added here.
            var pluralTerms = _.extend(
                {},
                NebulaComponents.nebulaI18nPluralTerms,
                PlatformComponents.i18nPluralTerms,
                platformPagesI18nPluralTerms
            );

            i18next.init(_.extend({}, {
                'interpolation': {
                    'prefixEscaped': '%\\(',
                    'suffixEscaped': '\\)[sd]'
                },
                'resources': {
                    'en': {
                        'translation': Object.keys(pluralTerms).reduce(function(acc, key) {
                            acc[key + '_plural'] = pluralTerms[key];
                            return acc;
                        }, {}),
                    },
                },
                'nsSeparator': false,
                'keySeparator': false
            }, options));
        },

        "addFilters": function (env) {

            env.addFilter('thousands', nunjucksFilters.thousands);

            env.addFilter('encode_uri', encodeURI);

            env.addFilter('encode_uri_component', encodeURIComponent);

            env.addFilter('style_thumbnail_for', nunjucksFilters.styleThumbnailFor);

            env.addFilter('thumbnail_url_for', nunjucksFilters.thumbnailUrlFor);

            env.addFilter('search_asset_type', nunjucksFilters.searchAssetType);

            env.addFilter('format_grades_for_template', nunjucksFilters.formatGradesForTemplate);

            env.addFilter('seconds_to_hhmmss', nunjucksFilters.secondsToHhmmss);

            env.addFilter('is_media_asset', nunjucksFilters.is_media_asset);

            env.addFilter('is_image_asset', nunjucksFilters.is_image_asset);

            env.addFilter('is_video_segment_asset', nunjucksFilters.is_video_segment_asset);

            env.addFilter('is_full_video_asset', nunjucksFilters.is_full_video_asset);

            env.addFilter('is_array', nunjucksFilters.is_array);

            env.addFilter('grade_bands', nunjucksFilters.grade_bands);

            env.addFilter('alnum', nunjucksFilters.alnum);

            env.addFilter('find_where', nunjucksFilters.find_where);

            env.addFilter('time_ago', nunjucksFilters.time_ago);

            env.addFilter('image_directory', nunjucksFilters.imageDirectory);

            env.addFilter('hyphenate', nunjucksFilters.hyphenate);

            env.addFilter('strftime', nunjucksFilters.strftime);

            env.addFilter('index_of', nunjucksFilters.index_of);

            env.addFilter('n2e', nunjucksFilters.n2e);

            env.addFilter('key_not_none', nunjucksFilters.key_not_none);

            env.addFilter('media_file_metadata', nunjucksFilters.media_file_metadata);

            env.addFilter('video_file_res', nunjucksFilters.video_file_res);

            env.addFilter('video_file_type', nunjucksFilters.video_file_type);

            env.addFilter('query_string', nunjucksFilters.query_string);

            env.addFilter('query_string_to_dict', nunjucksFilters.query_string_to_dict);

            env.addFilter('shuffle', nunjucksFilters.shuffle);

            env.addFilter('where', nunjucksFilters.where);

            env.addFilter('title', nunjucksFilters.title);

            /* Flask filters */
            env.addFilter('tojson', nunjucksFilters.toJSON);

            env.addFilter('striptags', nunjucksFilters.stripTags);

        },

        "addGlobals": function (env) {
            env.addGlobal('core_static', nunjucksGlobals.core_static);
            env.addGlobal('edde_static', nunjucksGlobals.edde_static);
            env.addGlobal('get_DE_url', nunjucksGlobals.get_DE_url);
            env.addGlobal('_', _.bind(nunjucksGlobals.i18n, i18next));
            env.addGlobal('ngettext', _.bind(nunjucksGlobals.ngettext, i18next));
        }
    };
});

